angular.module('autoremind.communications')
    .directive('speciesFilter', ['jobService', 'templateService',
    function (jobService, templateService) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-filter-species.html',
            link: function (scope) {
            }
        };
    }]);
//# sourceMappingURL=communications-filter-species.js.map